// removed by extract-text-webpack-plugin
module.exports = {"nav":"_1S1CLZX5wZoOTV1P6Zu67F","open":"_3Nget-rCuy5wWJJI_jU1Zz","navList":"_3qnPuyLD9Xr8lpicEdHPgK","navItem":"_2opaTEJzOOy5R_mqGYvRNa","navActiveItem":"_3lRNwcOs5UU2C0vBL4yz7B","navLangSwitch":"_37PFoQcyjnvbsaUcRsobTJ","switchLang":"_2qtcjqMvQhyux7NT1iPlg_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/Nav.css
// module id = 327
// module chunks = 0